import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import { AuthCard } from "@/components/auth/AuthCard";
import { useAuth } from "@/api/auth";

export default function ChangePasswordPage() {
  const { logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match");
      return;
    }
    setIsLoading(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Change failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthCard
      title="EVzone Media & Content Platform"
      subtitle="Change your password"
      footer={success ? <Link to="/auth/login">Sign in again</Link> : <Link to="/media-content/command-center">Cancel</Link>}
    >
      {success ? (
        <div className="ev-login__success" role="status">
          Password changed. For security, please sign in again.
          <div style={{ marginTop: 16 }}>
            <button className="ev-login__submit" onClick={() => logout()}>
              Sign out
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="ev-login__form">
          <label className="ev-login__field">
            <span>Current password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              disabled={isLoading}
              required
            />
          </label>
          <label className="ev-login__field">
            <span>New password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          <label className="ev-login__field">
            <span>Confirm new password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          {error && <div className="ev-login__error" role="alert">{error}</div>}
          <button type="submit" className="ev-login__submit" disabled={isLoading}>
            {isLoading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
    </AuthCard>
  );
}
